import React from 'react';
import { Box, Typography } from '@mui/material';
export default function Info({ title, data, isLast }) {
  return (
    <Box mb={isLast ? 0 : 3}>
      <Typography
        sx={{ color: '#828D9C', fontSize: '12px', fontWeight: '500' }}
      >
        {title}
      </Typography>
      <Typography variant="p" sx={{ color: '#1D1E24', mt: 1 }}>
        {data}
      </Typography>
    </Box>
  );
}
